import _ from 'lodash';
import { Collection } from 'backbone';

const onSuccess = function(type, model, { errors, result }){
	if (_.size(errors)) {
		this.trigger(`${type}:errors`, errors);
	}
	else {
		this.trigger(`${type}:success`, result);
	}
};

export default {
	/**
	 * Return result or response as is in case result field is missing
	 * @param resp
	 * @return {*} result from server
	 */
	parse: {
		value: function(resp) {
			return resp.result || resp;
		},
		writable: true,
		configurable: true
	},

	url: {
		/**
		 * Returns full API URL include prefix and method
		 * @returns {String}
		 */
		get() {
			return this.prefix + this.method_url;
		},
		/**
		 * Set methodUrl for API URL
		 * @param {String} method_url
		 */
		set(method_url) {
			if (!_.isString(method_url)) {
				throw new Error('URL field should be a string');
			}

			this.method_url = method_url;
		},
	},

	prefix: {
		/**
		 * Returns prefix for API URL
		 * @returns {String}
		 */
		get() {
			return this.url_prefix || '';
		},

		/**
		 * Set prefix for API URL
		 * @param {String} url_prefix
		 */
		set(url_prefix) {
			if (!_.isString(url_prefix)) {
				throw new Error('URL prefix field should be a string');
			}

			this.url_prefix = url_prefix;
		}
	},
	postData: {
		/**
		 * Post data to server and trigger event on success/errors
		 * @param {Object} data
		 * @param {String} type
		 */
		value: function({ data = {}, type = 'post' }) {
			const is_collection = this instanceof Collection;

			const args = {
				data,
				success: onSuccess.bind(...[
					this,
					type,
					// is_collection ? this : undefined
				])
			};

			return is_collection ? this.save(args) : this.save({}, args);
		},
		writable: true,
		configurable: true
	},
	getData: {
		/**
		 * Get data from the server and trigger event on success/errors
		 * @param {Object} data
		 * @param {String} type
		 */
		value: function({ data = {}, type = 'get' } = {}) {
			return this.fetch({
				data,
				success: onSuccess.bind(this, type)
			});
		},
		writable: true,
		configurable: true
	}
}